/**
 * Builds the deep-link URL + display product name for "Save this quote"
 * and "Resume draft" affordances on the Quote Calculator.
 *
 * Centralised here so the in-step inline render and the global render
 * share the exact same URL composition (otherwise it's easy to forget
 * to thread a new param through both call sites and end up with
 * "Resume draft" silently losing one piece of state).
 */
import { productData } from '../data/mockData';

/**
 * @param {object} state
 *   - selectedProduct, selectedFormat, selectedMaterial
 *   - width, height, unit, quantity
 *   - shippingMethod, step
 * @returns {string}  e.g. `/quote?p=stickers&f=die-cut&w=2&h=2&...&step=4`
 */
export const buildQuoteDraftUrl = ({
  selectedProduct,
  selectedFormat,
  selectedMaterial,
  width,
  height,
  unit,
  quantity,
  shippingMethod,
  step,
} = {}) => {
  // eslint-disable-next-line no-undef
  const p = new URLSearchParams();
  if (selectedProduct) p.set('p', selectedProduct);
  if (selectedFormat) p.set('f', selectedFormat);
  if (selectedMaterial) p.set('m', selectedMaterial);
  if (width) p.set('w', String(width));
  if (height) p.set('h', String(height));
  if (unit) p.set('u', unit);
  if (quantity) p.set('q', String(quantity));
  if (shippingMethod) p.set('s', shippingMethod);
  if (step !== undefined && step !== null) p.set('step', String(step));
  return `/quote?${p.toString()}`;
};

/**
 * Resolves a human-readable product name from current wizard selection.
 * Used by SaveQuoteButton and the sessionStorage draft mirror.
 *
 * Falls back through subcategory.name → category.name → '' so partially
 * complete drafts still get a sensible label in the UI.
 */
export const getQuoteProductName = (selectedProduct, selectedFormat) => {
  const cat = productData.categories.find((c) => c.id === selectedProduct);
  const sub = cat?.subcategories.find((s) => s.id === selectedFormat);
  return sub?.name || cat?.name || '';
};
